import { Component, OnInit } from '@angular/core';
import { MetricsService, Metric } from 'src/app/services/metrics.service';
import { ActivatedRoute } from '@angular/router';
import { RankingsService, Ranking } from 'src/app/services/rankings.service';
import { MetricRankingsService, MetricRanking, MetricRankingDetailed } from 'src/app/services/metric-rankings.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-weighting',
  templateUrl: './weighting.component.html',
  styleUrls: ['./weighting.component.scss']
})
export class WeightingComponent implements OnInit {

  rankingId: number;
  rankingName: string;
  rankingDate: string;
  rankingStatus: string;
  rankingEffectiveDate: Date;
  metrics: Metric[];
  metricRankingsIncoming: MetricRankingDetailed[];
  metricRankingsOutgoing: MetricRanking[] = [];
  submitMetricRankingsEvent: Subject<void> = new Subject<void>();
  enabledZeroWeight: boolean = false;
  outsideLimits: boolean = false;
  allowScoring: boolean = false;

  weightTotalPercent: string = " ( 0 / 100)";

  unsubscribe: Subject<any> = new Subject;

  constructor(
    private route: ActivatedRoute,
    public rankingsService: RankingsService,
    private metricsService: MetricsService,
    public metricRankingsService: MetricRankingsService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.rankingId = Number.parseInt(this.route.snapshot.params.rankingId);

    this.rankingsService.currentRanking
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(rank => {
        if (rank) {
          this.rankingName = rank.rankingName;
          this.rankingDate = new Date(rank.rankingDate).toLocaleDateString("en-US");
          this.rankingStatus = rank.rankingStatusName;
          this.rankingEffectiveDate = rank.effectiveDate;
        }
      });

    this.metricsService.getMetrics();

    this.metricsService.currentMetrics
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(metrics => this.metrics = metrics);

    this.metricRankingsService.getMetricRankings(this.rankingId);

    this.metricRankingsService.currentMetricRankings
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(metricRankings => this.metricRankingsIncoming = metricRankings);
    }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.metricsService.changeMetrics([]);
    this.metricRankingsService.changeMetricRankings([]);
  }

  triggerMetricRankings() {
    this.submitMetricRankingsEvent.next();
  }

  generateMetricRankingUpdate($event) {
    if ($event.metricRankingWeight <= 0 && $event.metricEnabled === true) {
      this.enabledZeroWeight = true;
    }
    if ($event.metricRankingWeight < 0 || $event.metricRankingWeight > 100) {
      this.outsideLimits = true;
    }
    this.metricRankingsOutgoing.push(this.removeExtraProperties($event));
    if (this.metricRankingsOutgoing.length === this.metricRankingsIncoming.length) {
        let weightingSum: number = this.metricRankingsOutgoing.filter(this.isEnabled).reduce(this.sum, 0);
        weightingSum = Math.ceil(weightingSum);
      if (this.enabledZeroWeight || this.outsideLimits) {
        if (this.enabledZeroWeight) {
            this.toastr.error("Deselect metrics weighted 0, or increase their weight.", "Error:");
            this.allowScoring = false;
        }
        if (this.outsideLimits) {
            this.toastr.error("Weight values must be between 0 and 100.", "Error:")
            this.allowScoring = false;
        }
      } else if(weightingSum === 100) {
          this.sendMetricRankingUpdate(this.metricRankingsOutgoing);
          this.allowScoring = true;
      } else {
          this.toastr.error('Weights do not add up to 100.', 'Error:');
          this.allowScoring = false;
      }
      this.metricRankingsOutgoing = [];
      this.enabledZeroWeight = false;
      this.outsideLimits = false;
    }
  }

  removeExtraProperties(metricRankingDetailed: any): MetricRanking {
    let temp: MetricRanking = {} as MetricRanking;
    temp.metricId = metricRankingDetailed.metricId;
    temp.metricRankingId = metricRankingDetailed.metricRankingId;
    temp.rankingId = metricRankingDetailed.rankingId;
    temp.metricId = metricRankingDetailed.metricId;
    temp.metricRankingWeight = metricRankingDetailed.metricRankingWeight;
    temp.metricEnabled = metricRankingDetailed.metricEnabled;
    return temp;
  }

  isEnabled = (metricRanking) => metricRanking.metricEnabled === true;

  sum = (sum, metricRanking) => sum + metricRanking.metricRankingWeight;
 

  sendMetricRankingUpdate(metricRankings: MetricRanking[]) {
    this.metricRankingsService.putMetricRankings(metricRankings);
  }

  addMetric($event) {
    let data: any = $event;
    data.rankingId = this.rankingId;
    let metricExists = (metric) => metric.metricName === data.metricName;
    let filteredMetrics = this.metrics.filter(metricExists);
    if(filteredMetrics.length) {
      data.metricId = filteredMetrics[0].metricId;
      this.metricRankingsService.postMetricRanking(data);
    } else {
      this.metricsService.postMetric(data);
    }
  }
  metricWeightChange(event) {
    var totalWeightSum = 0;
    var allInputs: any = document.getElementsByClassName('metric-ranking-row');
    for (var i = 0; i < allInputs.length; i++) {
      var input = allInputs[i];
      var checkboxIput = input.querySelector('.metric-enabled-class');
      if ((checkboxIput !== null) && (checkboxIput.checked === true)) {
        var checkboxIput = input.querySelector('.metric-weight');
        var weightInput = checkboxIput.querySelector('input'); // "28"
        totalWeightSum = totalWeightSum + parseInt(weightInput.value);
      }
    }
    this.weightTotalPercent = " (" + totalWeightSum.toString() + " / 100)";
  }
  toggleAllMetricsEnabled() {
    var allInputs: any = document.getElementsByName('metric-enabled');
    var toggleCheck: any = document.getElementById('metric-toggle');
    var checkedTrue: number = 0;
    var checkedFalse: number = 0;
    var checkedOn: boolean = false;

    allInputs.forEach(function (input) {
      if (input.checked === true) {
        checkedTrue = checkedTrue + 1;
      } else {
        checkedFalse = checkedFalse + 1;
      }
    });
    if (checkedTrue == (checkedTrue + checkedFalse)) {
      checkedOn = true;
    } else if (checkedFalse == (checkedTrue + checkedFalse)) {
      checkedOn = false;
    }

    allInputs.forEach(function (input) {
      input.checked = checkedOn;
      input.click(); // so the ng-model picks this up.
    });
    toggleCheck.checked = !checkedOn;
  }


}
